// extracted by mini-css-extract-plugin
export default {"reactions":"t3T57lub","label":"TMTKk3HW","input":"EXvePR3l","content":"FqX5NhBd","count":"SlZROqwi"};